module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message) ? _c('span', {
    staticClass: "help-block form-text text-danger"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ceacef6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-formly-bootstrap/src/components/errorDisplay.vue
// module id = 1087
// module chunks = 0